"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApisInstance = exports.ServiceApis = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_auth_refresh_1 = __importDefault(require("axios-auth-refresh"));
const fitjava_script_client_1 = require("@amzn/fitjava-script-client");
const base_apis_1 = require("./base_apis");
const CONSTANTS = __importStar(require("../common/constants"));
const fit_token_provider_1 = require("../auth/fit_token_provider");
const functions_1 = require("../common/functions");
const constants_1 = require("../common/constants");
class ServiceApis extends base_apis_1.Apis {
    static getBaseUrl() {
        const baseHref = window.location.hostname;
        let baseApiUrl = CONSTANTS.DEFAULT_URL;
        CONSTANTS.URL_API_MAP.forEach((value, key) => {
            if (baseHref.indexOf(key) != -1) {
                baseApiUrl = value;
            }
        });
        return baseApiUrl;
    }
    constructor() {
        super();
        this.client = axios_1.default.create({
            baseURL: ServiceApis.getBaseUrl(),
        });
        this.fitClientConfig = (0, fit_token_provider_1.getTokenProviderConfig)();
        this.client.interceptors.request.use((config) => {
            var _a;
            config.headers = (_a = config.headers) !== null && _a !== void 0 ? _a : {};
            const token = sessionStorage.getItem(fitjava_script_client_1.Constants.SESSION_STORAGE_ID_TOKEN_KEY);
            if ((0, functions_1.isEmptyString)(token)) {
                throw new Error('No Authorization token present');
            }
            config.headers['id-token'] = token;
            config.headers['audience-id'] = this.fitClientConfig.clientId;
            config.headers['process-id'] = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_PROCESS);
            return config;
        });
        (0, axios_auth_refresh_1.default)(this.client, this.refreshToken, {
            statusCodes: [401, 403],
        });
    }
    async refreshToken(failedRequest) {
        console.log('Request is forbidden, present token may expired, try to refresh the token');
        await fit_token_provider_1.tokenProviderInstance
            .refreshToken()
            .then((response) => {
            console.log('Token refreshed');
            return Promise.resolve();
        })
            .catch((error) => {
            const message = `Failed to refresh token due to ${error}`;
            console.log(message);
            return Promise.reject(message);
        });
    }
    async listProvisionDetails(input) {
        const response = await this.client.post(constants_1.EDM_LIST_PROVISION_DETAILS_API_NAME, input, {});
        return response.data.provisionDetailsList;
    }
    async getProvisionStatus(input) {
        const response = await this.client.post(constants_1.EDM_GET_PROVISION_STATUS_API_NAME, input, {});
        return response.data.provisionStatus;
    }
    async transactionalSaveProvisionDetails(input) {
        const response = await this.client.post(constants_1.EDM_TRANSACTIONAL_SAVE_PROVISION_DETAILS_API_NAME, input, {});
        return response.data;
    }
    async getClientInstanceInformationList(input) {
        const response = await this.client.post(constants_1.EDM_GET_CLIENT_INSTANCES_INFORMATION_API_NAME, input, {});
        return response.data.clientInstanceInformationList;
    }
    async getClientResourceTags(input) {
        const response = await this.client.post(constants_1.EDM_GET_CLIENT_RESOURCE_TAGS_API_NAME, input, {});
        return response.data.clientResourceTagList;
    }
    async deregisterDevice(input) {
        const response = await this.client.post(constants_1.EDM_DEREGISTER_DEVICE_API_NAME, input, {});
        return response.data.message;
    }
    async getProcessesForUser(input) {
        const response = await this.client.post(constants_1.EDM_GET_PROCESSES_FOR_USER_API_NAME, input, {});
        return response.data.processList;
    }
    async rebootDevice(input) {
        const response = await this.client.post(constants_1.EDM_REBOOT_DEVICE_API_NAME, input, {});
        return response.data;
    }
    async getProvisionInputTemplateUrls(input) {
        const response = await this.client.post('/getProvisionInputTemplateUrls', input, {});
        return response.data;
    }
}
exports.ServiceApis = ServiceApis;
exports.ServiceApisInstance = new ServiceApis();
